export enum TRACKING_EVENT_TYPE {
  ChangeSubscription = "change-subscription",
  ReactivateRenew = "reactivate-or-renew",
  CancelSubscription = "cancel-subscription",
  RevertCancellation = "revert-cancellation",
  AddOnPurchase = "addOn-purchase",
  ReactivateSubscription = "reactivate-subscription",
}
